import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlus, faCircleCheck, faHeart, faCommentDots, faBookmark, faShare, faTimes } from '@fortawesome/free-solid-svg-icons';
import './FooterRight.css';

function FooterRight({ likes, comments, saves, shares, profilePic }) {
  const [liked, setLiked] = useState(false);
  const [saved, setSaved] = useState(false);
  const [userAddIcon, setUserAddIcon] = useState(faCirclePlus);
  const [showCopyMessage, setShowCopyMessage] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [displayedComments, setDisplayedComments] = useState([]);

  // Expanded predefined comments about cuteness and animal love
  const predefinedComments = [
    { username: "BarkBoss", comment: "Omg stop 😭💖 too cute!" },
    { username: "Furball", comment: "I can't handle this 🥹❤️" },
    { username: "SnackCat", comment: "Pure joy 🐾💫" },
    { username: "ZoomQueen", comment: "My heart = stolen 🐶💘" },
    { username: "CuteOverdose", comment: "ILLEGAL LEVEL OF CUTE 😍🚨" },
    { username: "LeafVibes", comment: "Nature wins again 🌿✨" },
    { username: "FluffKing", comment: "That stare tho 😍🐾" },
    { username: "NapChamp", comment: "Can I hug it pls 🥺🐾" },
    { username: "TinyBean", comment: "Those eyes! 😍💘" },
    { username: "MeowMuse", comment: "Too precious 🐾✨" },
    { username: "PurrBuzz", comment: "This = serotonin 💖👏" },
    { username: "Sniffster", comment: "Magical moment ✨🌍" },
    { username: "ChonkLove", comment: "That face 😭💞" },
    { username: "FlopVibes", comment: "Needed this today 💛🌸" },
    { username: "TofuBoy", comment: "I'm OBSESSED 😍🌀" },
    { username: "WiggleBean", comment: "Instant mood boost 🥰💗" },
    { username: "CryMode", comment: "Protect at all costs 🛡️🐾" },
    { username: "ToastBoi", comment: "Innocence in eyes 🥺🍃" },
    { username: "BoopLord", comment: "My heart's melting 💓🔥" },
    { username: "PawsFirst", comment: "Deserves a million ❤️s!" }
  ];

  // Select random comments when the comment section is opened
  useEffect(() => {
    if (showComments) {
      // Shuffle the comments array and pick a random number between 5-8
      const shuffled = [...predefinedComments].sort(() => 0.5 - Math.random());
      const commentCount = Math.floor(Math.random() * 4) + 5; // Random number between 5-8
      setDisplayedComments(shuffled.slice(0, commentCount));
    }
  }, [showComments]);

  const handleUserAddClick = () => {
    if (userAddIcon === faCirclePlus) {
      setUserAddIcon(faCircleCheck);
    } else {
      setUserAddIcon(faCirclePlus);
    }
  };

  // Function to convert likes count to a number
  const parseLikesCount = (count) => {
    if (typeof count === 'string') {
      if (count.endsWith('K')) {
        return parseFloat(count) * 1000;
      }
      return parseInt(count);
    }
    return count;
  };

  // Function to format likes count
  const formatLikesCount = (count) => {
    if (count >= 10000) {
      return (count / 1000).toFixed(1) + 'K';
    }
    return count;
  };

  const handleLikeClick = () => {
    setLiked((prevLiked) => !prevLiked);
  };

  const handleCommentClick = () => {
    setShowComments(prev => !prev);
  };

  const handleShareClick = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        setShowCopyMessage(true);
        setTimeout(() => {
          setShowCopyMessage(false);
        }, 3000); // Message disappears after 3 seconds
      })
      .catch(err => {
        console.error('Failed to copy URL: ', err);
      });
  };

  return (
    <div className="footer-right">
      <div className="sidebar-icon">
        {profilePic ? (
          // Displaying the user profile picture
          <img src={profilePic} className='userprofile' alt='Profile' style={{ width: '45px', height: '45px', color: '#616161' }} onClick={handleUserAddClick}/>
        ) : null}
        {/* The user add icon */}
        <FontAwesomeIcon icon={userAddIcon} className='useradd' style={{ width: '15px', height: '15px', color: '#FF0000' }} onClick={handleUserAddClick}/>
      </div>
      <div className="sidebar-icon">
        {/* The heart icon for liking */}
        <FontAwesomeIcon
          icon={faHeart}
          style={{ width: '35px', height: '35px', color: liked ? '#FF0000' : 'white' }}
          onClick={handleLikeClick}
        />
        {/* Displaying the formatted likes count */}
        <p>{formatLikesCount(parseLikesCount(likes) + (liked ? 1 : 0))}</p>
      </div>
      <div className="sidebar-icon">
        {/* The comment icon */}
        <FontAwesomeIcon
          icon={faCommentDots}
          style={{ width: '35px', height: '35px', color: showComments ? '#1E88E5' : 'white' }}
          onClick={handleCommentClick}
        />
        {/* Displaying the number of comments */}
        <p>{comments}</p>

        {/* Comments overlay */}
        {showComments && (
          <div className="comments-overlay">
            <div className="comments-container">
              <div className="comments-header">
                <h3>Comments</h3>
                <FontAwesomeIcon
                  icon={faTimes}
                  className="close-comments"
                  onClick={handleCommentClick}
                />
              </div>
              <div className="comments-list">
                {displayedComments.map((item, index) => (
                  <div className="comment-item" key={index}>
                      <img src={`https://ui-avatars.com/api/?name=${item.username}&background=random&color=fff`} alt="User Avatar" className="comment-avatar" />
                    <div className="comment-content">
                      <p className="comment-username">@{item.username}</p>
                      <p className="comment-text">{item.comment}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="sidebar-icon">
        {saved ? (
          // Displaying the bookmark icon when saved
          <FontAwesomeIcon
            icon={faBookmark}
            style={{ width: '35px', height: '35px', color: '#ffc107' }}
            onClick={() => setSaved(false)}
          />
        ) : (
          // Displaying the bookmark icon when not saved
          <FontAwesomeIcon
            icon={faBookmark}
            style={{ width: '35px', height: '35px', color: 'white' }}
            onClick={() => setSaved(true)}
          />
        )}
        {/* Displaying the number of saves */}
        <p>{saved ? saves + 1 : saves}</p>
      </div>
      <div className="sidebar-icon">
        {/* The share icon */}
        <FontAwesomeIcon
          icon={faShare}
          style={{ width: '35px', height: '35px', color: 'white' }}
          onClick={handleShareClick}
        />
        {/* Displaying the number of shares */}
        <p>{shares}</p>
        {/* Message when URL is copied */}
        {showCopyMessage && (
          <span className="copy-message">Link copied! Share it with friends &#127873;</span>
        )}
      </div>
      <div className="sidebar-icon record">
        {/* Displaying the record icon */}
        <img src="https://static.thenounproject.com/png/934821-200.png" alt='Record Icon' />
      </div>
    </div>
  );
}

export default FooterRight;
